import { render, staticRenderFns } from "./IncomesVsExpenses.vue?vue&type=template&id=13b7d04f&scoped=true&"
import script from "./IncomesVsExpenses.vue?vue&type=script&lang=js&"
export * from "./IncomesVsExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b7d04f",
  null
  
)

export default component.exports